import { Outlet } from "react-router-dom";
import { NavigatorBar } from "./NavigatorBar";

// Simplified to always show NavigatorBar (public pages) until auth routes are reinstated.
export const Authenticator = () => {
  return <NavigatorBar />;
};
